module.exports = __webpack_public_path__ + "static/media/external-link-alt.4c6f22a8.svg";